module.exports = __webpack_public_path__ + "img/icon_add_idea.f3a31230.png";